// @ts-nocheck

import { BasketStatuses } from '../../../types/basket';
import { number as numberUtils } from '../../../utils/';

/**
 * Set main freebetId as boolean to be use as freebet balance
 * @param  {[type]} state  [description]
 * @param  {[type]} action [description]
 * @return {[type]}        [description]
 */
const basketSetFreebetBoolean = (state, action, { user }) => {
  const { stake, status, selectedFreebetId } = state;
  const { freebetId } = action.payload;
  const formattedUserBalance = user?.balance / 100;
  const formattedUserFreebetBankroll = user?.freebetBankroll / 100;
  const selectedBankroll = freebetId ? formattedUserFreebetBankroll : formattedUserBalance;
  const hasStakeAndBankroll = !!stake && !numberUtils.checkIsNaN(selectedBankroll); // use of checkIsNaN()
  // to prevent the stake to return a string like `NaN`

  if (status !== BasketStatuses.PENDING && status !== BasketStatuses.VALIDATED && status !== BasketStatuses.WAITING) {
    if (freebetId !== selectedFreebetId) {
      return {
        ...state,
        selectedFreebetId: freebetId,
        stake: hasStakeAndBankroll ? Math.min(Number(stake), selectedBankroll).toString() : stake,
        eligibleKLCollectibleId: freebetId ? null : state.eligibleKLCollectibleId,
        isGRActive: freebetId ? false : state.isGRActive,
        isMonopolyActive: freebetId ? false : state.isMonopolyActive,
        isBoomActive: freebetId ? false : state.isBoomActive,
      };
    }
  }
  return state;
};

export default basketSetFreebetBoolean;
